module.exports = __webpack_public_path__ + "static/media/isosistas.80a78585.gif";